const lifeBasics = [
	"Drinking Water",
	"Battery Energy",
	"Water",
	"Electricity",
	"Complete Medicines",
	"Food",
	"Full Treatment",
	"Anesthesia",
	"Fuel",
	"Natural Gas",
	"Quiet",
	"Safety",
	"Travel",
	"House",
	"Gauze",
	"Restaurant",
	"Medical Clinics",
	"Lighting",
	"Transportation",
	"Mosque",
	"Working School",
	"Working University",
	"Garden",
];

const LifeBasics = () => {
	return (
		<p className='life-basics-bar'><span>No</span> {lifeBasics[ Math.floor(Math.random() * lifeBasics.length) ]}</p>
	);
};

export default LifeBasics;